var t={latitude:-25.2744,longitude:133.7751},e=4;export{t as DEFAULT_LOCATION,e as DEFAULT_ZOOM_SCALE};
//# sourceMappingURL=GoogleMap.constants.js.map
